import React from 'react'
import { Button } from 'react-bootstrap'
import Icon from 'UI/FontAwesomeIcon'

const Export = ({ data, loading }) => {
  return (
    <form action="/integrations/status/data_protection" method="POST">
      {data.map(row => (
        <>
          <input
            type="hidden"
            name={`backup_report[][customer]`}
            value={row.customerName}
          />

          <input
            type="hidden"
            name={`backup_report[][storage_policy]`}
            value={row.storagePolicyName}
          />

          <input
            type="hidden"
            name={`backup_report[][commcell]`}
            value={row.commcellName}
          />

          <input
            type="hidden"
            name={`backup_report[][location]`}
            value={row.locationName}
          />

          <input
            type="hidden"
            name={`backup_report[][job_type]`}
            value={row.jobType}
          />

          <input
            type="hidden"
            name={`backup_report[][subclient]`}
            value={row.subclient}
          />

          <input
            type="hidden"
            name={`backup_report[][frequency]`}
            value={row.frequency}
          />

          <input
            type="hidden"
            name={`backup_report[][commvault_job_id]`}
            value={row.commvaultJobId}
          />

          <input
            type="hidden"
            name={`backup_report[][backup_level]`}
            value={row.backupLevel}
          />

          <input
            type="hidden"
            name={`backup_report[][latest_job_status]`}
            value={row.latestJobStatus}
          />

          <input
            type="hidden"
            name={`backup_report[][latest_job_start_time]`}
            value={`"${row.latestJobStartTime}"`}
          />

          <input
            type="hidden"
            name={`backup_report[][latest_job_end_time]`}
            value={`"${row.latestJobEndTime}"`}
          />

          <input
            type="hidden"
            name={`backup_report[][last_completed_job_time]`}
            value={`"${row.lastCompletedJobTime}"`}
          />
        </>
      ))}

      <Button type="submit" disabled={loading} variant="outline-primary">
        <Icon className="mr-2" icon="file-spreadsheet" />
        Export
      </Button>
    </form>
  )
}

export default Export
